import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardService } from 'src/app/services';

@Injectable({ providedIn: 'root' })
export class DashboardResolver {
  constructor(private dashboardService: DashboardService) {}

  resolve(): Observable<string[]> {
    return this.dashboardService.fakeCall$();
  }
}
